<template>
  <div class="default-title-wrapper" :style="{borderColor: theme}">
    <span class="title" :style="{color: theme}">{{ name }}</span>
  </div>
</template>

<script>
export default {
  props: ['name', 'theme']
}
</script>

<style lang="scss" scoped>
  .default-title-wrapper {
    border-bottom: 1px solid #404040;
    margin-bottom: 8px;
  }
  .title {
    display: inline-block;
    color: #404040;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
  }
</style>
